// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"caab4602d330cdaa","741":"3cec90b366b1e8d3","766":"c39a73cbeaf0a4b0"}[chunkId] + ".js";
};